// extracted by mini-css-extract-plugin
export default {"container":"edit-section_container__-ia+2","header":"edit-section_header__qDMKd"};